export default {
  // 模式
  "common.mode.auto": "Автономне використання",
  "common.mode.economy": "Економічний режим",
  "common.mode.exigency": "Режим екстреного випадку",

  // 设备
  "common.grid": "Електрична мережа",
  "common.evChargers": "Зарядні стійки для ЕМ",
  "common.evCharger": "Зарядний стійок для ЕМ",
  "common.pv": "ФотоВ (фотovoltaic)",
  "common.inverter": "Інвертор",
  "common.pcs": "Інвертор + батарея",
  "common.terminal": "Термінальне пристрої",
  "common.airc": "Кондиціонер",
  "common.engine": "Двигун",
  "common.battery": "Батарея",
  "common.metter": "Електрична лічильниця",
  "common.other": "Інше",
  "common.power": "Потужність",
  "common.powerTotal": "Загальна потужність",
  "common.voltage": "Напруга",
  "common.electricity": "Електроенергія",
  "common.current": "Ток",
  "common.homeUsage": "Загальневантаження будинку",
  "common.battery.power": "Потужність батареї",

  // 数据
  "common.noDataAvailable": "Дані ще не доступні~",
  "common.tips": "Підказка",
  "common.reset": "Скинути",
  "common.currencyUnit": "¥",
  "common.submiting": "Відправка триває, будь ласка, зачекайте...",
  "common.close": "Закрити",
  "common.from": "З",
  "common.useIn": "Для",
  "common.energyPercent": "Відсоток потоку енергії",
  "common.dataFlow": "Потік даних",
  "common.getDataIng": "Отримання даних триває, будь ласка, зачекайте...",
  "common.pageLoading": "Завантаження вмісту сторінки триває, будь ласка, зачекайте...",
  "common.reseting": "Скидання вмісту сторінки, будь ласка, зачекайте...",
  "common.save": "Зберегти",
  "common.onlyNumberTips": "Дозволяється ввести лише цифри",
  "common.offline": "Офлайн",
  "common.online": "Онлайн",
  "common.fault": "Помилка",
  "common.charge": "Заряджання",
  "common.discharge": "Розрядження",
  "common.buy": "Купити",
  "common.sell": "Продати",
  "common.loadingInfo": "Завантаження триває, будь ласка, зачекайте...",

  // 
  "common.moreFeatures": "Більше функцій",
  "common.confirm": "Підтвердити",
  "common.saveing": "Збереження триває, будь ласка, зачекайте...",
  "common.searchPlacholder": "Введіть ключове слово для пошуку",
  "common.iSee": "Зрозуміло",
  "common.pageErrorTips1": "Ой, сталася помилка на сторінці~",
  "common.pageErrorTips2": "Спробуйте оновити сторінку або зв'язатися з підтримкою~",
  "common.refresh": "Оновити",
  "common.backToHome": "Повернутися на головну",
  "common.checkTips": "Перевірка триває, будь ласка, зачекайте...",
  "common.back": "Повернутися",
  "common.cancel": "Скасувати",
  "common.optional": "Необов'язкове",
  "common.required": "Обов'язкове",
  "common.status": "Статус",
  "common.statusNoDelete": "Не видалено",
  "common.statusDelete": "Видалено",
  "common.submit": "Відправити",
  "common.disable": "Заблокувати",
  "common.enable": "Активувати",
  "common.year": "рік",
  "common.month": "місяць",
  "common.day": "день",
  "common.version": "Версія:",
  "common.backHome": " Повернутися на головну",
  "common.backHomeSorry": " Нажаль, сторінка випадково зникла",
  "common.requestTips1": "Обробка даних триває, не відправляйте повторно",
  "common.requestTips2": "Сповіщення системи",
  "common.requestTips3": "Статус входу минув, увійдіть знову",
  "common.requestTips4": "Увійти знову",
  "common.requestTips5": "Недійсна сесія або сесія минув, увійдіть знову.",
  "common.requestTips6": "Помилка сервера, будь ласка, спробуйте пізніше.",
  "common.requestTips7": "Таймаут запиту до системи",
  "common.requestTips8": "Системний інтерфейс",
  "common.requestTips9": "Помилка",
  "common.iknow": "Зрозуміло",
  "common.logoutSuccess": "Вихід успішний",
  
  // 了解更多组件
  "common.knowMore.title": "Для отримання додаткових інформацій зв'яжіться з Beineng",
  "common.knowMore.email": "Електронна пошта для зв'язку",
  "common.knowMore.phone": "Телефон для зв'язку",
  "common.knowMore.wechat": "WeChat для зв'язку",
  "common.knowMore.website": "Адреса офіційного сайту",
  "common.knowMore.address": "Адреса для зв'язку",
  "common.knowMore.addressDetail": "кімнати 1205, 1301, корпус 5, провулок Цинхе, 8, Хуанцзінькен, селище Хуанцян, місто Дуньгуань, провінція Гуандун",
  
  // 本地连接组件
  "common.localConnection": "Локальне з'єднання",
  "common.operateInApp": "Робіть дії в додатку!",
  
  "common.enbleStaus": "Статус активності",
  "common.battery.status": "Без заряду та розряду",

  "account.forgetThePassword": "Забули пароль",
  "account.logInDirectly": "Перейти до входу",
  "account.tips1": "Перехід на сторінку триває, будь ласка, зачекайте...",
  "account.tips2": "Спочні прочитайте та згодніться з умовами користування!",
  "account.autoLogin": "Автоматичний вхід",
  "account.userLogin": "Вхід користувача",
  "account.registerTips": "Ще немає облікового запису? Натисніть тут, щоб зареєструватися",
  "account.userEmail": "Ім'я користувача/електронна пошта",
  "account.userEmailTips": "Введіть ім'я користувача або електронну пошту",
  "account.password": "Пароль",
  "account.passwordTips": "Введіть пароль",
  "account.submit": "Відправити",
  "account.submitTips": "Відправка триває, будь ласка, зачекайте...",
  "account.otherLoginTips": "Або виберіть інший спосіб входу",
  "account.userRegistration": "Реєстрація користувача",
  "account.userName": "Ім'я користувача",
  "account.userNameTips": "Введіть ім'я користувача",
  "account.emailTips1": "Введіть адресу електронної пошти",
  "account.emailTips2": "Неправильний формат адреси електронної пошти",
  "account.phone": "Номер телефону",
  "account.phoneTips1": "Введіть номер телефону",
  "account.phoneTips2": "Неправильний номер телефону",
  "account.phoneTips3": "Введіть номер телефону",
  "account.passwordTips1": "Введіть пароль (6-30 символів)",
  "account.passwordTips2": "Неправильний формат паролю: пароль повинен складатися з англійських літер, цифр, підкреслень, дефісів та крапок, довжина 6-12 символів",
  "account.passwordTips3": "Два введення паролю не співпадають, перевірте та введіть знову!",
  "account.passwordTips4": "Введіть пароль: пароль повинен складатися з англійських літер, цифр, підкреслень, дефісів та крапок",
  "account.passwordTips5": "Підтвердження паролю",
  "account.passwordTips6": "Введіть підтвердження паролю",
  "account.passwordTips7": "Два введення паролю не співпадають, перевірте та введіть знову!",
  "account.passwordTips8": "Введіть підтвердження паролю",
  "account.passwordTips9": "Вітаємо, реєстрація успішна!",
  "account.passwordTips10": "Ваше ім'я користувача:",
  "account.emailIs": "Електронна пошта:",
  "account.goToLoginPage": "Після s секунд автоматично перейдете на сторінку входу",
  "account.goLogin": "Увійти",
  "account.goRegister": "Зареєструватися",
  "account.loginSuccess": "Вхід успішний",
  "account.email": "Електронна пошта",
  "account.sologn": "Створюємо індивідуальний план енергопостачання для вас",
  "account.pleaseAgree": "Я прочитав(ла) та згоден(на) з",
  "userAgreement.privacyPolicy": "політикою конфіденційності",

  "account.code": "Код підтвердження",
  "account.codeTips": "Введіть код підтвердження",
  "account.codeTips2": "Неправильний код підтвердження",

    "account.inviteCodeTips": "Будь ласка, введіть код запрошення",
    "account.inviteCodeHint": "Для отримання коду запрошення зверніться до монтажника або персоналу з експлуатації та обслуговування",
  "account.modifyPasswordByAccount": "Зміна паролю за обліковим записом",
  "account.modifyPasswordByEmail": "Зміна паролю за електронною поштою",
  "account.getPasswordByAccount": "Відновлення паролю за обліковим записом",
  "account.getPasswordByEmail": "Відновлення паролю за електронною поштою",

  "account.sendEmailTips": "Код підтвердження надіслано на електронну пошту, перевірте її",
  "account.name": "Назва облікового запису",
  "account.newPassword": "Новий пароль",
  "account.confirmNewPassword": "Підтвердження нового паролю",
  "account.nameTips": "Введіть назву облікового запису",
  "account.passwordModifySuccess": "Зміна паролю успішна",
  "account.emailCode": "Код підтвердження на електронну пошту",
  "account.emailCodeTips": "Введіть код підтвердження на електронну пошту",
  "account.emailCodeTips2": "Неправильний код підтвердження на електронну пошту",
  "account.emailModifySuccess": "Зміна паролю успішна",
  "account.passworTips1": "Ваш пароль успішно скинуто!",
  "account.passwordTips11": "Введіть підтвердження паролю",
  "account.passwordTips12": "Введіть новий пароль",
  "account.nickname": "Нікнейм користувача",
  "account.modifyNickname": "Зміна нікнейму користувача",
  "account.modifyNicknameSuccess": "Зміна нікнейму користувача успішна!",
  "account.nicknameTips": "Введіть нікнейм користувача",
  "account.nicknameError": "Зміна нікнейму користувача не вдалася!",

  "account.login": "Увійти",
  "account.quickRegister": "Швидка реєстрація",
  "account.sendCode": "Надіслати код",
  "account.sendTips": "Після s секунд можна відправити знову",
  "account.sendEmailIng": "Відправка електронної пошти триває, будь ласка, зачекайте...",
  "account.emailNotEmpty": "Адреса електронної пошти не може бути порожньою",
  "account.registerAccount": "Зареєструвати обліковий запис",
  "account.registerWelcome": "Ласкаво просимо до реєстрації в SusprSafe",
  "account.usernameLimit": "Ім'я користувача повинно починатися з літери та містити лише літери, цифри та підкреслення, довжина 5-15 символів",

  "copyright.desc2": "Інформація про реєстрацію сайту: реєстрація ICP Гуандун № 2021169764",

  "editUserInfo.editUserInformation": "Редагування інформації про користувача",
  "editUserInfo.modifyUsername": "Зміна імені користувача",
  "editUserInfo.changePictures": "Зміна аватара",
  "editUserInfo.savePicturesSuccess": "Аватар користувача успішно збережений",
  "editUserInfo.saveError": "Збереження не вдалось",
  "editUserInfo.pictureLimit": "Розмір зображення повинен бути менше 2 МБ",
  "editUserInfo.uploadPicture": "Завантажити аватар",
  "editUserInfo.picturePreview": "Попередній перегляд",
  
  "editUserInfo.bindPhoneNumber": "Приєднати номер телефону",
  "editUserInfo.bindEmail": "Приєднати електронну пошту",
  "editUserInfo.changePassword": "Зміна паролю",

  "editUserInfo.notificationSettings": "Налаштування сповіщень",
  "editUserInfo.editAccount": "Редагування інформації про обліковий запис користувача",
  "editUserInfo.waitBingting": "Приєднання триває, будь ласка, зачекайте...",
  "editUserInfo.collapse": "Згорнути",
  "editUserInfo.modifyBinding": "Зміна приєднання",
  
  "editUserInfo.emailAddress": "Адреса електронної пошти",
  "editUserInfo.tips1": "Приєднання електронної пошти успішне",
  "editUserInfo.tips2": "Збереження не вдалось",
  "editUserInfo.tips3": "Відправка коду підтвердження на електронну пошту триває, будь ласка, зачекайте...",
  "editUserInfo.tips4": "Код підтвердження надіслано на електронну пошту xxxx, перевірте її",
  "editUserInfo.tips5": "Відправка коду підтвердження не вдалася!",
  "editUserInfo.tips6": "Номер телефону вже приєднаний",
  "editUserInfo.tips7": "Електронна пошта вже приєднана",
  "editUserInfo.emailTips1": "Введіть адресу електронної пошти",
  "editUserInfo.emailTips2": "Неправильний формат адреси електронної пошти",
  "editUserInfo.emailTips3": "Після xxxx секунд можна відправити знову",
  "editUserInfo.emailTips4": "Надіслати код",
  "editUserInfo.emailTips5": "Код підтвердження на електронну пошту не може бути порожнім",
  "editUserInfo.emailTips6": "Неправильний код підтвердження на електронну пошту",
  "editUserInfo.emailCode": "Код підтвердження на електронну пошту",
  "editUserInfo.save": "Зберегти",

  "editUserInfo.phoneTips1": "Приєднання номера телефону успішне",
  "editUserInfo.phoneTips2": "Відправка SMS-коду підтвердження триває, будь ласка, зачекайте...",
  "editUserInfo.phoneTips3": "SMS-код підтвердження надіслано на телефон xxxx, перевірте його",
  "editUserInfo.phoneTips4": "Відправка SMS-коду підтвердження не вдалася!",
  "editUserInfo.phoneTips5": "Введіть номер телефону",
  "editUserInfo.phoneTips6": "Неправильний формат номера телефону",
  "editUserInfo.phoneTips7": "Надіслати SMS-код підтвердження",
  "editUserInfo.phoneTips8": "SMS-код підтвердження",
  "editUserInfo.phoneTips9": "SMS-код підтвердження не може бути порожнім",
  "editUserInfo.phoneTips10": "Неправильний SMS-код підтвердження",
  "editUserInfo.phone": "Номер телефону",


  "editUserInfo.noticeTips1": "Отримання налаштувань сповіщень не вдалось!",
  "editUserInfo.noticeTips2": "Налаштування сповіщень успішно збережено!",
  "editUserInfo.noticeTips3": "Сповіщення про низький рівень заряду батареї",
  "editUserInfo.noticeTips4": "Сповіщення про завершення заряду на зарядному стійку",
  "editUserInfo.errorNotification": "Сповіщення про помилку",
  "editUserInfo.updateNotification": "Сповіщення про оновлення",
  "editUserInfo.monthlyStatisticsNotification": "Сповіщення про щомісячні статистики",
  "editUserInfo.notificationMethod": "Спосіб отримання",

  "editUserInfo.userNameTips1": "Ім'я користувача успішно збережено",
  "editUserInfo.userNameTips2": "Збереження імені користувача не вдалось",
  "editUserInfo.userNameTips3": "Введіть ім'я користувача",
  "editUserInfo.userNameTips4": "Неправильний формат імені користувача: повинно складатися з цифр, підкреслень та англійських літер",
  "editUserInfo.userNameTips5": "Введіть ім'я користувача",
  "editUserInfo.userNameTips6": "Збереження триває, будь ласка, зачекайте...",
  "editUserInfo.userName": "Ім'я користувача",

  "editUserInfo.avatorTips": "Натисніть, щоб змінити аватар",
  "editUserInfo.verifyCodeTips1": "Введіть отриманий код підтвердження:",
  "editUserInfo.verifyCodeTips2": "Для безпеки вашого облікового запису Натисніть кнопку нижче, щоб надіслати код підтвердження на оригінальний номер телефону:",
  "editUserInfo.verifyCodeTips3": "Надіслати код",
  "editUserInfo.verifyCodeTips4": "Перевірка оригінального телефону успішна, введіть новий приєднаний номер телефону",
  "editUserInfo.verifyCodeTips5": "Для безпеки вашого облікового запису Натисніть кнопку нижче, щоб надіслати код підтвердження на оригінальну електронну пошту:",
  "editUserInfo.verifyCodeTips6": "Перевірка оригінальної електронної пошти успішна, введіть нову електронну пошту",
  "editUserInfo.verifyCodeTips7": "Старий пароль",
  "editUserInfo.verifyCodeTips8": "Спочні приєднайте електронну пошту!",
  "editUserInfo.verifyCodeTips9": "Код підтвердження надіслано на електронну пошту, перевірте її",
  "editUserInfo.verifyCodeTips10": ", автоматично перейдете на сторінку входу",

  "hems.notice.title": "Заголовок сповіщення", 
  "hems.notice.content": "Вміст сповіщення", 
  "hems.notice.operate": "Дія",
  "hems.notice.noRead": "Непрочитане",
  "hems.notice.read": "Прочитане",
  "hems.notice.warning": "Попередження",
  "hems.notice.error": "Помилка",
  "hems.notice.success": "Статистична обробка",
  "hems.notice.sys": "Системна інформація",
  "hems.notice.operateSuccess": "Дія успішна",
  "hems.notice.operateTips": "Виберіть елемент для дії",

  // 首页
  "hems.home.selfuseRate": "Рівень автономного використання",
  "hems.home.percent": "Відсоток",
  "hems.home.todayData": "Сьогоднішні дані",
  "hems.home.todayPowerGeneration": "Сьогоднішня виробка енергії",
  "hems.home.salesIncome": "Дохід від продажу енергії",
  "hems.home.saved": "Ви заощаджали",
  "hems.home.reduce": "Зниження вуглецевої сліди",
  "hems.home.tips1": "Дані ще не доступні, ви ще не приєднали xxxx",
  "hems.home.criticalLoad": "Критичневантаження",
  "hems.home.keyVoltage": "Критична напруга",
  "hems.home.householdLoad": "Вантаження будинку",
  "hems.home.householdVoltage": "Напруга будинку",
  "hems.home.generalLoad": "Звичайневантаження",
  "hems.home.generalVoltage": "Звичайна напруга",
  "hems.home.batteryHealth": "Стан здоров'я батареї",
  "hems.home.averageTemp": "Середня температура",
  "hems.home.gridLoad": "Вантаження електричної мережі",
  "hems.home.toggeleDataSource": "Нинішні відображаємі дані змінено на:",
  "hems.home.toggleTips": "Ви впевнені, що хочете змінити?",
  "hems.home.modeSending": "Відправка команди режиму триває, будь ласка, зачекайте...",
  "hems.home.modeSuccess": "Команда зміни режиму успішно надіслана!",
  "hems.home.isOnline": "Чи онлайн?",
  "hems.home.useStatus": "Статус використання",
  "hems.home.workModeText": "Нинішній робочий режим:",
  "hems.home.toggleDataSourceText": "Нинішні відображаємі дані змінено на:",
  "hems.ev.charge.status": "Статус заряду",
  "hems.ev.charge.time": "Тривалість заряду",
  "hems.ev.charge.count": "Реальний обсяг заряду",
  "hems.ev.charge.status.empty": "Вільний",
  "hems.ev.charge.status.ing": "Заряджання з підключеною кабелем",
  "hems.ev.charge.status.null": "Кабель підключений, але без заряду",
  "hems.ev.charge.status.error": "Помилка",
  "hems.hour": "година",
  "hems.minue": "хвилина",
  "hems.ev.chagre.number": "Номер зарядного стійку",

  // User Guide
  "hems.userGuide.selfUse": "Автономне використання",
  "hems.userGuide.selfUseTips": "Спочні використовуйте фотovoltaicну енергію, при нестачі доповніть з електричної мережі",
  "hems.userGuide.economyMode": "Економічний режим",
  "hems.userGuide.economyModeTips": "Оптимізація стратегії використання енергії за ціною електроенергії",
  "hems.userGuide.emergencyMode": "Режим екстреного випадку",
  "hems.userGuide.emergencyModeTips": "Спочні забезпечити живлення критичноговантаження",

  // 图表页面
  "hems.history.energyStatistics": "Статистика енергії",
  "hems.history.revenueStatistics": "Статистика доходів",
  "hems.history.greenStatistics": "Зелена редукція викидів",
  "hems.history.revenueTitle": "Загальний дохід від продажу енергії",
  "hems.history.savingsTitle": "Загальні заощадження",
  "hems.history.carbonTitle": "Загальне зниження вуглецевих викидів",
  "hems.history.day": "день",
  "hems.history.month": "місяць",
  "hems.history.year": "рік",
  "hems.history.beforeDay": "вчора",
  "hems.history.afterDay": "завтра",
  "hems.history.beforeMonth": "минул. міс.",
  "hems.history.afterMonth": "наступ. міс.",
  "hems.history.beforeYear": "минул. rok.",
  "hems.history.afterYear": "наступ. rok.",
  "hems.history.totalUse": "Загальне використання",
  "hems.history.fullScreen": "Повний екран",
  "hems.history.timeSelect": "Вибір дати",
  "sync.tips1": "Команда синхронізації даних успішно надіслана!",
  "sync.tips2": "Синхронізація даних триває, через великий обсяг даних це займає час, перевірте через півгодини~",
  "sync.tips3": "Синхронізація даних пристрою може мати запізнення, якщо ви помітите невідповідності в даних, Натисніть:",
  "sync.tips4": "Синхронізувати дані",

  "charge.info": "Інформація про зарядний стійок",
  "news.loading": "Завантаження триває...",
  "news.noMore": "Немає більше елементів",
  "hems.pv.power": "Обсяг енергії від фотоВ",

  // UEH specific
  "ueh.sellPower": "Обсяг проданої енергії",
  
  "menu.home": "Головна",
  "menu.history": "Історичні дані",
  "menu.device": "Пристрої",
  "menu.settings": "Налаштування",
  "menu.messageCenter": "Центр повідомлень",
  "menu.help": "Допомога та підтримка",
  "menu.mine": "Мої",


  "mine.userSetting": "Налаштування користувача",
  "mine.terminalSetting": "Базові налаштування терміналу",
  "mine.uploadCloud": "Збереження даних у хмарі",
  "mine.changeVersion": "Перевірити оновлення",
  "mine.language": "Зміна мови",
  "mine.about": "Про додаток",
  "mine.feedback": "Зворотний зв'язок",
  "mine.logout": "Вийти з облікового запису",
  "mine.logoutAccount": "Видалити обліковий запис",

  "mine.logoutAccountTips": "Видалити обліковий запис з ім'ям []",
  "mine.logoutAccountTips1": "Видалити обліковий запис, приєднаний до []",
  "mine.logoutAccountCare": "Рекомендації при запиті видалення облікового запису:",
  "mine.logoutAccountCare1": "1. Обліковий запис знаходиться в безпечному стані",
  "mine.logoutAccountCare1-1": "Обліковий запис працює в нормальному режимі, немає ризику злому, порушення правил або блокування.",
  "mine.logoutAccountCare2": "2. Авторизації та приєднання облікового запису видалені",
  "mine.logoutAccountCare2-1": "Всі авторизації облікового запису з іншими третіми платформами видалені.",
  "mine.logoutAccountCare3": "3. Після видалення облікового запису його неможливо відновити, дані користувача видаляються",
  "mine.logoutAccountCare3-1": "Після видалення облікового запису приєднаний номер телефону, електронна пошта та інші дані видаляються і неможливо їх відновити.",
  "mine.confirmLogout": "Підтвердити видалення",
  "mine.logoutSuccess": "Обліковий запис успішно видалений!",


  "mine.feedbackIssues": "Зворотний зв'язок про проблеми",
  "mine.feedQuantity": "Кількість",
  "mine.feedAmount": "Максимум 9 зображень, максимальний розмір 1 МБ/зображення",

  "mine.notice.fail": "Отримання налаштувань сповіщень не вдалось!",
  "mine.notice.saveSuccess": "Налаштування сповіщень успішно збережено!",
  "mine.notice.saveFail": "Збереження не вдалось!",
  "mine.notice.title": "Налаштування сповіщень",
  "mine.notice.batteryLow": "Сповіщення про низький рівень заряду батареї",
  "mine.notice.chargingFinish": "Сповіщення про завершення заряду на зарядному стійку",
  "mine.notice.error": "Сповіщення про помилку",
  "mine.notice.update": "Сповіщення про оновлення",
  "mine.notice.monthly": "Сповіщення про щомісячні статистики",
  "mine.notice.receiveType": "Спосіб отримання",

  "mine.language.welcome": "Ласкаво просимо до SusprSafe",
  "mine.language.desc1": "Виберіть мовну версію за вашим місцем проживання",
  "mine.language.desc2": "Ви можете змінити її в будь-який час у налаштуваннях додатку",

  "mine.userInfo.avatar": "Аватар",
  "mine.userInfo.nickname": "Нікнейм",
  "mine.userInfo.password": "Пароль",
  "mine.userInfo.changePassword": "Зміна паролю",
  "mine.userInfo.setPassword": "Встановити пароль",
  "mine.userInfo.phoneNumber": "Номер телефону",
  "mine.userInfo.bindPhone": "Приєднати номер телефону",
  "mine.userInfo.bindEmail": "Приєднати електронну пошту",
  "mine.loginExpired": "Статус входу минув, увійдіть знову",
  "mine.userInfo.title": "Інформація про користувача",
  "mine.userInfo.bind": "Приєднати",
  "mine.userInfo.modify": "Редагувати",
  "mine.userInfo.modifyNickname": "Зміна нікнейму",
  "mine.userInfo.userNickname": "Нікнейм користувача",
  "mine.userInfo.selectPic": "Виберіть зображення для завантаження",
  "mine.userInfo.saveSuccess": "Збереження успішне",
  "mine.userInfo.uploadFail": "Завантаження не вдалось",
  "mine.userInfo.avatarSaveSuccess": "Аватар успішно збережений",
  "mine.userInfo.nameTips1": "Нікнейм користувача не може бути порожнім",
  "mine.userInfo.nameTips2": "Введіть нікнейм користувача",

  "common.pleaseSelect": "Будь ласка, виберіть",
  "question.commonQuestions": "Часті запитання",
  "account.toggleLanguage": "Зміна мови",
  "account.localConnection": "Локальне з'єднання",
  "account.selectLanguage": "Будь ласка, виберіть мову",
  "account.sendEmailToast": "Код підтвердження надіслано на електронну пошту xxx, перевірте її",
  "account.emailError": "Неправильний формат електронної пошти",
  "account.sendEmailFail": "Відправка не вдалася, спробуйте знову",
  
  "common.submitting": "Відправка триває, будь ласка, зачекайте...",

  "device.page.noData": "Дані ще не доступні, цю сторінку можна переглянути лише в додатку"
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};